import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../../lib/helpers';

import Button from '../../../../components/Button/Button';

import { TrashIcon } from '../../../../images/shapes';

import { useFieldContext, useFormContext } from '../../../form';

const HeaderField = ({ onRemove, index, disabled, testId }) => {
  const { t } = useTranslation();

  const field = useFieldContext();
  const form = useFormContext();

  const handleRemove = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);

  return (
    <div
      className={twMerge(
        'relative p-4',
        'border border-solid border-gray dark:border-slate-800 rounded-lg mb-4',
      )}
      {...getTestProps(testId, `wrap-${index}`)}
    >
      <Button
        type="button"
        buttonSize="sm"
        buttonColor="borderless"
        onClick={handleRemove}
        iconImage={<TrashIcon className="w-3" />}
        additionalClasses={twMerge(
          'absolute right-2 top-2 group p-0',
          'm-0 w-7 h-7 group-hover:opacity-50 z-10',
        )}
        additionalIconClasses={'hover:opacity-50 selection-none'}
        disabled={disabled}
        {...getTestProps(testId, `delete-${index}`, 'testId')}
      />

      <form.AppField name={`${field.name}.header_name`}>
        {(field) => (
          <field.Input
            label={t('Webhooks.HeaderName')}
            additionalClasses={'mb-4'}
            disabled={disabled}
            required
            {...getTestProps(testId, `name-${index}`, 'testId')}
          />
        )}
      </form.AppField>

      <form.AppField name={`${field.name}.header_value`}>
        {(field) => (
          <field.Input
            label={t('Webhooks.HeaderValue')}
            disabled={disabled}
            required
            {...getTestProps(testId, `value-${index}`, 'testId')}
          />
        )}
      </form.AppField>
    </div>
  );
};

export default HeaderField;
